module.exports = __webpack_public_path__ + "static/img/wsjtg.5bcc212.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/wsjtg.png
// module id = 0e+u
// module chunks = 0